import Config from '../../conf';
const Theme = Config.THEME;

export const ConfirmDetails = {
  card: {
    padding: 30,
    paddingTop: 40,
    textAlign: 'center',
    borderRadius: 12
  },
  title: {
    textAlign: 'center',
    margin: 0,
    color: Theme.palette.primary1Color,
    marginBottom: 20
  },
  button: {
    width: 100,
    marginTop: 20,
    marginLeft: 5,
    marginRight: 5
  },
  field: {
    padding: 0,
    margin: 0,
    marginTop: -15,
    width: '100%'
  },
  fieldHintStyle: {
    textAlign: 'center'
  },
  table: {
    paddingLeft: '25%',
    paddingRight: '25%',
    paddingTop: 30,
    paddingBottom: 20
  },
  nameCol: {
    textAlign: 'center',
    fontWeight: 'bold'
  },
  valueCol: {
    textAlign: 'center'
  }
};

export const index = {
  container: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  gap: {
    marginTop: '3vh'
  },
  navbar: {
    height: 120,
    backgroundColor: '#fff'
  },
  navbarInner: {
    height: 120,
    marginTop: 0,
    textAlign: 'center'
  },
  imageLogo: {
    marginTop: 10,
    marginLeft: 9,
    height: 100,
    width: '100%',
    maxWidth: 400
  }
};

export const Payment = {
  card: {
    padding: 30,
    paddingTop: 40,
    textAlign: 'center',
    borderRadius: 12
  },
  title: {
    textAlign: 'center',
    margin: 0,
    color: Theme.palette.primary1Color,
    marginBottom: 20
  },
  button: {
    width: 100,
    marginTop: 20,
    marginLeft: 5,
    marginRight: 5
  },
  field: {
    padding: 0,
    margin: 0,
    marginTop: -15,
    width: '100%'
  },
  fieldHintStyle: {
    textAlign: 'center'
  },
  table: {
    paddingLeft: '25%',
    paddingRight: '25%',
    paddingTop: 30,
    paddingBottom: 20
  },
  nameCol: {
    textAlign: 'center',
    fontWeight: 'bold'
  },
  valueCol: {
    textAlign: 'center'
  }
};




// WEBPACK FOOTER //
// ./src/app/components/sms_payment/sms_payment.css.js